import {NextRouter, useRouter} from 'next/router';

import {RESPONSE_STATUSES} from '@/src/app/constants/api';
import useUserActions from '@/src/app/store/user/useUserActions';
import getRedirectUrl from '@/src/app/utils/getRedirectUrl';
import useLoading from '@/src/hooks/useLoading';
import useRoutePaths from '@/src/hooks/useRoutePaths';

import SignIn from '../components/SignIn';
import signInUser from '../utils/signInUser';

const SignInContainer = () => {
  const {isLoading, setLoading} = useLoading();
  const {push, query}: NextRouter = useRouter();
  const {setUserData} = useUserActions();
  const {DISCOVER, RESEND_EMAIL_ROUTE} = useRoutePaths();

  const handleSubmit = async (values, {setFieldError}) => {
    if (isLoading) return;

    setLoading(true);
    const {status, responseBody} = await signInUser(values);
    setLoading(false);

    if (status === RESPONSE_STATUSES.SUCCESS) {
      setUserData(responseBody);
    } else if (status === RESPONSE_STATUSES.UNPROCESSABLE) {
      push({
        pathname: RESEND_EMAIL_ROUTE.getLink(),
        query: `email=${values.email}`,
      });
    }

    if (
      status === RESPONSE_STATUSES.SUCCESS &&
      Object.prototype.hasOwnProperty.call(query, 'redirectPage')
    ) {
      // @ts-ignore
      return push(getRedirectUrl(query.redirectPage, query.redirectPageId));
    }

    if (status === RESPONSE_STATUSES.SUCCESS) {
      return push(DISCOVER.getLink());
    }

    if (
      responseBody &&
      responseBody.error &&
      typeof responseBody.error === 'object'
    ) {
      for (const key in responseBody.error) {
        if (Object.prototype.hasOwnProperty.call(responseBody.error, key)) {
          setFieldError(key, responseBody.error[key]);
        }
      }
    }
    if (
      responseBody &&
      responseBody.error &&
      typeof responseBody.error !== 'object'
    ) {
      setFieldError('general', responseBody.error);
    }
  };
  return <SignIn handleSubmit={handleSubmit} isLoading={isLoading} />;
};
export default SignInContainer;
